
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 49"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M5.705 4.186h6.456v10.068H5.705zM5.705 17.835h6.456v10.067H5.705zM5.705 32.186h6.456v10.068H5.705zM39 39a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0","fill":"#D0EFEC"}}),_c('g',{staticClass:"i-combo-lock",attrs:{"stroke":"#234652"}},[_c('circle',{staticClass:"i-Ellipse 10",attrs:{"cx":"37","cy":"39.5","r":"3.5"}}),_c('path',{staticClass:"i-Rectangle 18",attrs:{"d":"M35 36.5v-2a2 2 0 1 1 4 0v2"}}),_c('circle',{staticClass:"i-Ellipse 14",attrs:{"cx":"37","cy":"39.5","r":".5"}})]),_c('g',{staticClass:"i-database",attrs:{"stroke":"#234652"}},[_c('path',{staticClass:"i-Rectangle 908",attrs:{"d":"M2.5 6h37v10h-37z"}}),_c('path',{staticClass:"i-Rectangle 909",attrs:{"d":"M39.536 27.5v-8H2.591v11h26.25"}}),_c('path',{staticClass:"i-Rectangle 910",attrs:{"d":"M27 33.99H2.553V44.5H27"}}),_c('path',{staticClass:"i-Rectangle 911",attrs:{"d":"M7 16.5v3"}}),_c('path',{staticClass:"i-Rectangle 912",attrs:{"d":"M7 30.5v4"}}),_c('path',{staticClass:"i-Rectangle 913",attrs:{"d":"M35 16.5v3"}})]),_c('circle',{staticClass:"i-Ellipse 604",attrs:{"cx":"37.057","cy":"38.28","r":"9.608","stroke":"#234652"}})])
          )
        }
      }
    